<template>
  <div class="week-viatic margin-responsive" style="width: 100%">
    <b-card style="width: 100%; font-family: 'Roboto'">
      <template #header>
        <h4
          class="w-100 text-center text-primary h2 font-weight-bolder text-uppercase rounded"
        >
          {{ $t("CURRENT WEEK") }}
          <span class="ml-2">
            {{ initDate | myDateEs }} - {{ endDate | myDateEs }}</span
          >
        </h4>
      </template>
      <div class="d-flex justify-content-end">
        <div>
          <kendo-datepicker
            class="form-control-kendo"
            :class="[isDarkSkin ? ' bg-transparent' : '']"
            :min="minDate"
            :max="maxDate"
            v-model="week"
            :format="'MM/dd/yyyy'"
            name="created_date"
            id="created_date"
          ></kendo-datepicker>
        </div>
      </div>
      <!-- generated days of current week -->
      <b-card-text
        class="mt-1 d-flex justify-content-md-center justify-content-around align-items-center flex-wrap"
      >
        <div
          v-for="(item, index) in daysOfWeek"
          :key="index"
          class="text-center pl-1 pr-1 mb-1"
        >
          <label for="" class="text-center font-responsive">
            <b style="opacity: 0.8; font-size: 15px" class="text-uppercase">{{
              $t(item.date)
            }}</b>
            <br />
            <span style="opacity: 0.4; font-size: 15px"
              >{{ item.day | myDayMonth }}
            </span>
          </label>

          <div>
            <!-- <b-avatar rounded variant="light-warning" :size="iconSize">
              <feather-icon icon="AlertTriangleIcon" />
            </b-avatar> -->

            <b-avatar
              rounded
              :variant="resolvColor(item.homework_status_id)"
              :size="iconSize"
            >
              <span v-if="item.homework_status_id">
                {{ item.abbreviation }}
              </span>
              <feather-icon v-else icon="AlertTriangleIcon" />
            </b-avatar>
          </div>

          <div
            :class="
              item.amount > 0 && item.is_viatic ? 'text-success' : 'text-danger'
            "
            style="margin-top: 4px; font-size: 12px"
          >
            S/.{{ item.is_viatic ? item.viatic_cost : 0 | currencyZero }}
          </div>
        </div>
      </b-card-text>
      <div class="my-footer my-border footer-h mit border-success mt-3">
        <div class="h4 text-white">
          {{ $t("amount") | capitalize }} :
          <span :class="amount > 0 ? 'text-success' : 'text-danger'">
            S/ {{ amount | currencyZero }}
          </span>
        </div>
        <!--  <div class="mx-1 h4 text-white">-</div>
        <div class="h4 text-white ml-2">
          {{ $t("Viatic Status") }}
          <b-badge variant="light-success"> {{ $t("REGISTERED") }}</b-badge>
        </div> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import DashboardService from "@/views/driver/views/dashboard/services/dashboard.service.js";

export default {
  name: "CardViatic",
  computed: {
    ...mapGetters({
      windowWidth: "app/getWindowWidth",
      currentUser: "auth/currentUser",
    }),

    iconSize() {
      if (this.windowWidth < 300) {
        return 23;
      } else {
        return 30;
      }
    },
  },
  data() {
    return {
      daysOfWeek: [],
      total: 0,
      amount: 0,
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      week: "",
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().startOf("week").add(7, "days").format("YYYY-MM-DD"),
      namesDay: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
    };
  },

  methods: {
    async getWeekViaticByEmployee() {
      try {
        this.addPreloader();
        this.daysOfWeek = [];
        const params = {
          employee_id: this.currentUser.employee_id,
          init_date: this.initDate,
          end_date: this.endDate,
        };

        const { data } = await DashboardService.getWeekViaticByEmployee(params);
        this.namesDay.map((row) => {
          const day = {
            id: data[row].id,
            day: data[row].day,
            date: row.toUpperCase(),
            full_date: data[row].date || null,
            homework_status_id: data[row].homework_status_id || null,
            abbreviation: data[row].abbreviation || null,
            viatic_cost: data[row].viatic_cost || 0,
            is_viatic: data[row].viatic_cost || false,
            status: 1,
            amount: 34,
          };
          this.daysOfWeek.push(day);
        });
        // this.daysOfWeek.push();
        this.amount = data.is_viatic == "Apply" ? data.viatic_amount : 0;
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
  },
  created() {
    this.week = this.initDate;
    // this.getWeekViaticByEmployee();
  },
  watch: {
    week(newVal, oldVal) {
      this.daysOfWeek = [];
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");

      this.getWeekViaticByEmployee();
      return;
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(1, "days").format("MM-DD"),
      //   date: this.namesDay[0],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(2, "days").format("MM-DD"),
      //   date: this.namesDay[1],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(3, "days").format("MM-DD"),
      //   date: this.namesDay[2],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(4, "days").format("MM-DD"),
      //   date: this.namesDay[3],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(5, "days").format("MM-DD"),
      //   date: this.namesDay[4],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(6, "days").format("MM-DD"),
      //   date: this.namesDay[5],
      //   status: 1,
      //   amount: 34,
      // });
      // this.daysOfWeek.push({
      //   day: moment(newVal).startOf("week").add(7, "days").format("MM-DD"),
      //   date: this.namesDay[6],
      //   status: 1,
      //   amount: 34,
      // });

      // this.amount = 250;
    },
  },
};
</script>

<style scoped>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}

.week-viatic {
  display: flex;
  flex-wrap: wrap;
}

.day-viatic {
  flex-basis: calc(100% / 7);
  height: 150px;
}

.my-border {
  border-radius: 10px;
}

.my-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

@media (min-width: 483px) and (max-width: 2000px) {
  /* Estilos específicos para pantallas con un ancho entre 601px y 1200px */
  .footer-h {
    height: 60px;
  }

  .mit {
    padding-top: 5px;
  }

  .font-responsive {
    font-size: 18px;
  }
}

@media (max-width: 482px) {
  /* Estilos específicos para pantallas con un ancho entre 601px y 1200px */
  .footer-h {
    height: 100px;
    text-align: center;
  }

  .font-responsive {
    font-size: 15px;
  }
}
</style>